import { DockingViewState } from 'owa-editor-docking-plugin';

const DEFAULT_CARET_MARGIN = 2;

// Get a scrollTop value to make the cursor visible
export default function getScrollTopForCursor(
    dockingViewState: DockingViewState,
    scrollContainerScrollTop: number,
    containerBottom: number,
    cursorBottom: number,
    bottomDockingHeight: number
): number {
    const bottomOverflow =
        cursorBottom -
        (containerBottom - bottomDockingHeight - dockingViewState.scrollBarHeight) +
        DEFAULT_CARET_MARGIN;

    // Scroll cursor into view if needed
    if (dockingViewState.isBottomDocking && bottomOverflow > 0) {
        scrollContainerScrollTop += bottomOverflow;
    }

    return scrollContainerScrollTop;
}
